<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" size="lg" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Community
      </h6>
      <div>
        <base-button
          type="primary"
          class="mb-4 float-right"
          @click="editModal = false"
          >Import</base-button
        >
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class=" cursor-pointer  mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <CustomerList />
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <div class="">
      <div
        class="back-button flex  items-center shadow-md cursor-pointer bck-btn-css"
        @click="handleClick"
      >
        <feather-icon class="p-2 cursor-pointer" icon="ChevronLeftIcon" />
        <span class="font-bold">Back</span>
      </div>
      <Templates />
      <div class="form mt-8">
        <div>
          <router-view />
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import Templates from "./components/Templates.vue";
import CustomerList from "./components/CustomerList";
import "../../scss/Index.scss";

// import CustomerList from "./components/CustomerList.vue";
export default {
  data() {
    return {
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,

        minuteIncrement: 60
      },
      time: "",
      showUserList: false,
      editModal: false
    };
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "admin-campaign" });
    }
  },
  components: {
    Templates,
    CustomerList

    // CustomerList
  }
};
</script>
<style>
.vs-input--placeholder {
  left: 5px !important;
  top: 4px !important;
}
.caption-textbox {
  background: #f4f5f6;

  border-radius: 6px;
}
.line-h30 {
  line-height: 30px;
}
.bck-btn-css {
  background: #f4f5f6;
  width: 10%;
  border-radius: 3px;
  padding: 2px 0px;
}
.popup-width800 > .vs-popup {
  width: 800px !important;
}
.vs-table--tbody-table th {
  background: #f4f5f6 !important;
}
.text-muted-g {
  color: #626262;
}
</style>
